import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from "mobx-react";
import { Alert, Collapse, Row, Col } from "react-bootstrap";
import { Form } from "formsy-react-components";
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from "react-cookie";
import { Heading, ContainerBox } from "../AdminStyle";
import { instanceOf } from "prop-types";
import { LogeButtonSlim, LodgeButtonLoadingRing } from "../../GeneralStyle";
import Parse from "parse";
import ContractTable from "../../Tables/ContractTable";
import InvoiceTable from "../../Tables/InvoiceTable";
import MemberTable from "../../Tables/MemberTable";
import CompanyInputs from "./Inputs/CompanyInputs";

export const requiredFields = [
  "sortingNumber",
  "name",
  "shortname",
  "postcode",
  /*"uidNumber",*/ "phone",
  "contactEmail",
  "location",
  /*"billingAddress",*/ "coins",
  "street" /*"vat"*/,
];

@inject("adminStore")
@observer
class CompanyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,

      companyImage: null,
      imageUploading: false,
      imageUploaded: false,

      isLoading: false,
      loadingState: 0, // 0: Normal State, 1: Success, 2: Failure, 3: Successfully Created New
      buttonText: "SPEICHERN",

      partner: this.props.partner,
      contract: {
        fee: undefined,
        year: new Date().getFullYear() + 1,
      },
      restictState: 0, // 0: default, 1: loading, 2: success, 3: error
      banState: 0, // 0: default, 1: loading, 2: success, 3: error
      newContractState: 0, // 0: default, 1: loading, 2: success, 3: error
      deleteState: 0, // 0: default, 1: confirmation, 2: loading, 3: success, 4: error

      error: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.updateStates = this.updateStates.bind(this);

    this.findSortingNumber();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partner !== this.props.partner) {
      this.setState({ partner: this.props.partner });
      this.findSortingNumber();
    }
  }

  findSortingNumber = () => {
    if (this.state.partner.sortingNumber) return;

    const companyQuery = new Parse.Query("Company");
    companyQuery.descending("sortingNumber");
    companyQuery.lessThanOrEqualTo("sortingNumber", 9000);

    companyQuery.first().then((res) => {
      this.setState({
        partner: {
          ...this.props.partner,
          sortingNumber: res.get("sortingNumber") + 1,
        },
      });
    });
  };

  restrict = () => {
    this.setState({ restictState: 1 });
    Parse.Cloud.run("restrictAccess", { company: this.state.partner })
      .then((result) => {
        this.setState({ restictState: 2 });

        setTimeout(() => {
          this.setState({
            restictState: 0,
            partner: { ...this.state.partner, role: "restictedUsers" },
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({ restictState: 3 });
      });
    return;
  };

  newContract = async () => {
    this.setState({ newContractState: 1 });

    const config = await Parse.Config.get();

    Parse.Cloud.run("createContract", {
      companyid: this.state.partner.objectId,
      fee: config.get("YEARLY_FEE"),
      pending: true,
      year: -1,
    })
      .then((result) => {
        this.setState({ newContractState: 2 });
        this.props.history.push(
          `/internal/admin/contracts/${result.contractId}`
        );
      })
      .catch((error) => {
        this.setState({ newContractState: 3 });
      });
    return;
  };

  grant = () => {
    this.setState({ restictState: 1 });
    Parse.Cloud.run("grantAccess", { company: this.state.partner })
      .then((result) => {
        this.setState({ restictState: 2 });

        setTimeout(() => {
          this.setState({
            restictState: 0,
            partner: { ...this.state.partner, role: "standardUsers" },
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({ restictState: 3 });
      });
    return;
  };

  block = () => {
    this.setState({ banState: 1 });
    Parse.Cloud.run("blockAccess", { company: this.state.partner })
      .then((result) => {
        this.setState({ banState: 2 });

        setTimeout(() => {
          this.setState({
            banState: 0,
            partner: { ...this.state.partner, role: "bannedUsers" },
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({ banState: 3 });
      });
    return;
  };

  unblock = () => {
    this.setState({ banState: 1 });
    Parse.Cloud.run("unblockAccess", { company: this.state.partner })
      .then((result) => {
        this.setState({ banState: 2 });

        setTimeout(() => {
          this.setState({
            banState: 0,
            partner: { ...this.state.partner, role: "standardUsers" },
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({ banState: 3 });
      });
    return;
  };

  delete = () => {
    if (this.state.deleteState !== 1) {
      this.setState({ deleteState: 1 });
      setTimeout(() => {
        if(this.state.deleteState !== 1) return
        this.setState({ deleteState: 0 });
      }, 10000)
      return;
    }

    this.setState({ deleteState: 2 });

    Parse.Cloud.run("deleteCompany", { id: this.state.partner.objectId })
      .then((result) => {
        this.setState({ deleteState: 3 });
        console.log('success');
      })
      .catch((error) => {
        this.setState({ deleteState: 4 });
        console.log('error', error);
      });
    return;
  };

  // Reset button when form changes
  updateStates = () => {
    this.setState({
      isLoading: false,
      loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
      buttonText: "SPEICHERN",
    });
  };

  onSubmit = () => {
    this.setState({
      isLoading: true,
    });

    const company = this.state.partner;

    // Setting new image identifier if new image has been added
    company.logo =
      this.state.companyImage !== null ? this.state.companyImage : company.logo;
    delete company.industries;
    delete company.tags;
    //
    // If the company already has an objectId it is an existing one and it is updated
    //

    if (company.objectId) {
      console.log(company.region);
      // company.region = company.region && { className: "Region", __type: "Pointer", objectId: company.region.objectId }

      Parse.Cloud.run("updateCompanyById", {
        data: { ...company, region: company.region.slug },
      })
        .then((result) => {
          // Setting states for proper button rendering
          this.setState({
            isLoading: false,
            loadingState: 1,
            buttonText: "GESPEICHERT",
          });
        })
        .catch((error) => {
          // Setting states for proper button rendering
          this.setState({
            isLoading: false,
            loadingState: 2,
            buttonText: "ERNEUT",
            error: error.message.message,
          });
          console.error("error", error);
        });
      return;
    }

    //
    // If the company does not have an objectId it is a new one and it is created
    //

    Parse.Cloud.run("addCompany", {
      data: { ...company, region: company.region.slug },
      createContract: true,
      contractFee: this.state.contract.fee,
      year: this.state.contract.year,
    })
      .then((result) => {
        // Setting states for proper button rendering
        this.setState({
          isLoading: false,
          loadingState: 3,
          buttonText: "GESPEICHERT",
        });

        setTimeout(() => {
          this.props.history.push("/internal/admin/companies");
        }, 1.5 * 1000);
      })
      .catch((error) => {
        // Setting states for proper button rendering
        this.setState({
          isLoading: false,
          loadingState: 2,
          buttonText: "ERNEUT",
          error: error.message.message,
        });
        console.error("error", error);
      });
  };

  onRowClickMembers = (row) => {
    this.props.history.push(`/internal/admin/members/${row.objectId}`);
  };

  onRowClickContract = (row) => {
    this.props.history.push(`/internal/admin/contracts/${row.objectId}`);
  };

  render() {
    const isButtonDisabled = () => {
      // Use HTML validation for now
      return false;

      const partner = this.state.partner;
      const contract = this.state.contract;

      if (!partner.objectId && (contract.fee == null || contract.fee === ""))
        return true;

      for (let item of requiredFields) {
        if (partner[item] === "" || partner[item] == null) {
          return true;
        }
      }

      // Check If Mail is Valid
      // partner["email"] should only be tested if not empty

      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        partner["email"] &&
        (!re.test(String(partner["email"]).toLowerCase()) ||
          !re.test(String(partner["contactEmail"]).toLowerCase()))
      )
        return true;

      return false;
    };

    const members = this.props.members;
    const contracts = this.props.contracts;
    const invoices = this.props.invoices;

    return (
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <ContainerBox>
          <Row style={{ paddingTop: 25, margin: "auto" }}>
            <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
              {this.state.partner && this.state.partner.objectId
                ? this.props.partner.name
                : "Neue Firma anlegen"}
            </Heading>
            <div
              style={{
                paddingLeft: 0,
                marginLeft: 37,
                borderBottom: "1px solid rgb(33,45,61,15%)",
                width: "25%",
                marginBottom: 20,
              }}
            ></div>

            <Collapse in={this.state.showAlert}>
              <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                <h4>Kein gültiger Login</h4>
                <p>
                  Sie haben entweder ein falsches Passwort oder einen falschen
                  Benutzernamen eingegeben!
                </p>
              </Alert>
            </Collapse>

            <Form
              className={"dashboard-form"}
              onSubmit={this.onSubmit}
              onChange={this.updateStates}
              layout={"vertical"}
              validatePristine={true}
              disabled={this.state.loadingState === 3}
            >
              <CompanyInputs
                onChange={(state) => this.setState(state)}
                data={this.state.partner}
                requiredFields={requiredFields}
                contract={this.state.contract}
              />

              <Col
                md={12}
                className="text-center"
                style={{
                  paddingBottom: 45,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    position: "absolute",
                    display: "block",
                    left: 0,
                    right: 0,
                    top: 14,
                    /* Conditional rendering of text according to loadingState */
                    transform:
                      this.state.loadingState !== 0 &&
                      this.state.loadingState !== 3
                        ? "translateY(50px)"
                        : this.state.loadingState === 3
                        ? "translateY(100px)"
                        : "none",
                    color:
                      this.state.loadingState === 2
                        ? "rgb(217, 83, 79)"
                        : "#DAB777",
                  }}
                >
                  {this.state.loadingState === 0
                    ? ""
                    : this.state.loadingState === 1 ||
                      this.state.loadingState === 3
                    ? "Erfolgreich gespeichert"
                    : this.state.error}
                </p>
                {this.state.loadingState !== 3 && (
                  <div>
                    <LodgeButtonLoadingRing
                      style={{
                        transform: this.state.isLoading
                          ? "translateX(90px)"
                          : "none",
                      }}
                    ></LodgeButtonLoadingRing>
                    <LogeButtonSlim
                      style={{
                        position: "relative",
                        display: "flex",
                        margin: "auto !important",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#FFF",
                      }}
                      disabled={isButtonDisabled()}
                      hoverFontColor={"white"}
                      // Conditional rendering of button according to loadingState
                      {...(this.state.loadingState === 2
                        ? {
                            color: "rgb(217, 83, 79)",
                            fontColor: "rgb(217, 83, 79)",
                          }
                        : {})}
                    >
                      {this.state.buttonText}
                    </LogeButtonSlim>
                  </div>
                )}
              </Col>
            </Form>
            {this.state.loadingState === 3 && (
              <Col
                md={12}
                className="text-center"
                style={{
                  paddingBottom: 55,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <LogeButtonSlim
                  style={{
                    position: "relative",
                    display: "flex",
                    margin: "auto !important",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#FFF",
                  }}
                  hoverFontColor={"white"}
                  onClick={() =>
                    this.props.history.push("/internal/admin/members/new")
                  }
                >
                  neues Mitglied anlegen
                </LogeButtonSlim>
              </Col>
            )}
            {(this.state.loadingState === 1 ||
              this.state.loadingState === 3) && (
              <Col
                md={12}
                className="text-center"
                style={{
                  paddingBottom: 75,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <LogeButtonSlim
                  style={{
                    position: "relative",
                    display: "flex",
                    margin: "auto !important",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#FFF",
                  }}
                  hoverFontColor={"white"}
                  onClick={() =>
                    this.props.history.push("/internal/admin/companies")
                  }
                >
                  zurück zur Liste
                </LogeButtonSlim>
              </Col>
            )}
          </Row>
        </ContainerBox>

        {this.state.partner && this.state.partner.objectId && (
          <Row>
            <Col md={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <ContainerBox style={{ marginTop: 0 }}>
                <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                  Mitglieder
                </Heading>
                <div
                  style={{ color: "black", margin: "15px 35px 35px 35px" }}
                  className={"bootstrap-table users"}
                >
                  <MemberTable data={members} onRowClick="details" />
                </div>
              </ContainerBox>
            </Col>
            <Col md={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
              <ContainerBox style={{ marginTop: 0 }}>
                <Heading
                  style={{
                    paddingLeft: 0,
                    marginLeft: 37,
                    display: "inline-block",
                  }}
                >
                  Verträge
                </Heading>
                <LogeButtonSlim
                  hoverFontColor={"white"}
                  onClick={this.newContract}
                  style={{ float: "right", marginRight: 37 }}
                >
                  {this.state.newContractState === 1
                    ? "Loading..."
                    : this.state.newContractState === 2
                    ? "Vertrag erstellt"
                    : this.state.newContractState === 3
                    ? "Fehler"
                    : "Vertrag erstellen"}
                </LogeButtonSlim>
                <div
                  style={{ color: "black", margin: "15px 35px 35px 35px" }}
                  className={"bootstrap-table users"}
                >
                  <ContractTable
                    data={contracts}
                    hide={["acceptLink", "company"]}
                    onRowClick="details"
                  />
                </div>
              </ContainerBox>
            </Col>
            <Col md={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
              <ContainerBox style={{ marginTop: 0 }}>
                <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                  Rechnungen
                </Heading>
                <div
                  style={{ color: "black", margin: "15px 35px 35px 35px" }}
                  className={"bootstrap-table users"}
                >
                  <InvoiceTable
                    data={invoices}
                    hide={["contract", "company"]}
                    onRowClick="details"
                  />
                </div>
              </ContainerBox>
            </Col>
            <Col md={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <ContainerBox
                style={{ marginTop: 0, padding: "20px 15px 35px 15px" }}
              >
                <Heading style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  Werkzeuge
                </Heading>
                <Row>
                  <Col md={12}>
                    {this.state.partner.role != "bannedUsers" ? (
                      <div>
                        {this.state.partner.role &&
                        this.state.partner.role != "restrictedUsers" ? (
                          <LogeButtonSlim
                            hoverFontColor={"white"}
                            onClick={this.restrict}
                            style={{ marginRight: 20 }}
                            disabled={
                              this.state.restictState === 1 ||
                              this.state.restictState === 2
                            }
                          >
                            {this.state.restictState === 1
                              ? "Loading..."
                              : this.state.restictState === 2
                              ? "Buchungsrechte entzogen"
                              : this.state.restictState === 3
                              ? "Fehler"
                              : "Buchungsrechte entziehen"}
                          </LogeButtonSlim>
                        ) : (
                          <LogeButtonSlim
                            hoverFontColor={"white"}
                            onClick={this.grant}
                            style={{ marginRight: 20 }}
                            disabled={
                              this.state.restictState === 1 ||
                              this.state.restictState === 2
                            }
                          >
                            {this.state.restictState === 1
                              ? "Loading..."
                              : this.state.restictState === 2
                              ? "Buchungsrechte gegeben"
                              : this.state.restictState === 3
                              ? "Fehler"
                              : "Buchungsrechte geben"}
                          </LogeButtonSlim>
                        )}

                        <LogeButtonSlim
                          style={{
                            backgroundColor: "rgb(217, 83, 79)",
                            border: "none",
                          }}
                          hoverFontColor={"white"}
                          fontColor={"white"}
                          onClick={this.block}
                          disabled={
                            this.state.banState === 1 ||
                            this.state.banState === 2
                          }
                        >
                          {this.state.banState === 1
                            ? "Loading..."
                            : this.state.banState === 2
                            ? "Zugriff gesperrt"
                            : this.state.banState === 3
                            ? "Fehler"
                            : "Zugriff sperren"}
                        </LogeButtonSlim>
                      </div>
                    ) : (
                      <LogeButtonSlim
                        style={{
                          backgroundColor: "rgb(217, 83, 79)",
                          border: "none",
                        }}
                        hoverFontColor={"white"}
                        fontColor={"white"}
                        onClick={this.unblock}
                        disabled={
                          this.state.banState === 1 || this.state.banState === 2
                        }
                      >
                        {this.state.banState === 1
                          ? "Loading..."
                          : this.state.banState === 2
                          ? "Zugriff freigegeben"
                          : this.state.banState === 3
                          ? "Fehler"
                          : "Zugriff freigeben"}
                      </LogeButtonSlim>
                    )}
                  </Col>
                </Row>
              </ContainerBox>
            </Col>
            <Col md={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <ContainerBox
                style={{ marginTop: 0, padding: "20px 15px 35px 15px" }}
              >
                <Heading style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  Danger Area
                </Heading>
                <Row>
                  <Col md={12}>
                    <LogeButtonSlim
                      style={{
                        backgroundColor: "rgb(217, 83, 79)",
                        border: "none",
                      }}
                      hoverFontColor={"white"}
                      fontColor={"white"}
                      onClick={this.delete}
                      disabled={
                        this.state.banState === 2 || this.state.banState === 3
                      }
                    >
                      {this.state.deleteState === 1
                        ? "Sind sie sicher? Diese aktion kann nicht Rückgängig gemacht werden"
                        : this.state.deleteState === 2
                        ? "Loading..."
                        : this.state.deleteState === 3
                        ? "Unternehmen gelöscht"
                        : this.state.deleteState === 4
                        ? "Fehler"
                        : "Unternehmen unwiderruflich löschen"}
                    </LogeButtonSlim>
                  </Col>
                </Row>
              </ContainerBox>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

CompanyForm.propTypes = {
  userStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(withRouter(CompanyForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/CompanyForm.js